// Set per stage in Jenkins from SSM. The key ships in the bundle, so it must
// be referrer-restricted to the widget hosts.
export const GOOGLE_MAPS_API_KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY || ''

export const SOURCE = {
  PO: 'PO',
  PG: 'PG'
}

export const REVIEW_TYPE = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
}

export const RECOMMEND_QUESTION = 'Would you recommend our practice to others?'

export const STAR_CAPTIONS = {
  1: 'Very Disappointed',
  2: 'Not Impressed',
  3: 'Okay Experience',
  4: 'Good Experience',
  5: 'Great Experience'
}

export const STAR_CAPTION_DEFAULT = 'Rate and review your experience:'
